export const isExternalHttpUrl = (value = '') => /^https?:\/\//i.test(String(value).trim());

export const normalizeInternalPath = (value = '/') => {
    const normalized = String(value || '/').trim();
    if (!normalized) {
        return '/';
    }
    return normalized.startsWith('/') ? normalized : `/${normalized}`;
};

export const toRoutablePath = (value, fallback = '/') =>
    isExternalHttpUrl(value) ? normalizeInternalPath(fallback) : normalizeInternalPath(value || fallback);

export const toRedirectUrl = (value, origin) => {
    if (isExternalHttpUrl(value)) {
        return value;
    }

    return `${origin}${normalizeInternalPath(value)}`;
};
